import React from "react";

const PrivacyPolicy = () => {
  return (
    <>
      {/* Hero Banner */}
      <section
        className="position-relative"
        style={{
          height: "280px",
          backgroundImage: "url('/images/privacy-banner.jpg')", // Replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="position-absolute top-0 start-0 w-100 h-100"
          style={{
            background: "rgba(0,0,0,0.35)",
          }}
        ></div>

        <div className="container h-100 position-relative">
          <div className="row h-100 align-items-end">
            <div className="col-12 pb-5">
              <h2 className="text-white fw-normal">Privacy Policy</h2>
            </div>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="py-5 bg-white">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="bg-white p-lg-5 p-4 shadow-sm">
                <p className="small">
                  At Save Hornbills, conservation begins with trust.
                </p>

                <p>
                  This Privacy Policy explains how information may be collected,
                  used, and protected when you visit or interact with our
                  website. We believe privacy should be handled with
                  transparency, simplicity, and respect.
                </p>

                <p>
                  By using the website, you agree to the practices outlined
                  below.
                </p>

                <h6 className="fw-bold mt-4">What We Do</h6>

                <p>
                  Save Hornbills is a conservation awareness initiative
                  dedicated to highlighting endangered bird species,
                  supporting wildlife education, and encouraging responsible
                  conservation efforts across Africa and beyond.
                </p>

                <p>
                  Our platform may include educational resources,
                  conservation stories, research summaries, and links to
                  trusted partner organizations involved in habitat
                  protection and wildlife recovery.
                </p>

                <h6 className="fw-bold mt-4">
                  Information We Collect
                </h6>

                <p>
                  We may collect limited personal information when users:
                </p>

                <ul>
                  <li>Contact us through forms or email</li>
                  <li>Subscribe to newsletters or conservation updates</li>
                  <li>Submit inquiries or feedback</li>
                  <li>Interact with website features</li>
                  <li>Visit pages and browse website content</li>
                </ul>

                <p>This information may include:</p>

                <ul>
                  <li>Name</li>
                  <li>Email address</li>
                  <li>Country or region (optional)</li>
                  <li>Inquiry or message content</li>
                  <li>Anonymous browsing or device information</li>
                </ul>

                <p>
                  We collect only the information necessary to operate and
                  improve the website experience.
                </p>

                <h6 className="fw-bold mt-4">
                  How We Use Information
                </h6>

                <p>Information may be used to:</p>

                <ul>
                  <li>Respond to messages or support requests</li>
                  <li>Share conservation updates and educational content</li>
                  <li>Improve website functionality and performance</li>
                  <li>Understand visitor engagement</li>
                  <li>Maintain website security</li>
                  <li>Prevent spam or misuse</li>
                </ul>

                <p>
                  We do not sell personal information to advertisers or
                  unrelated third parties.
                </p>

                <h6 className="fw-bold mt-4">
                  Donation & External Payment Platforms
                </h6>

                <p>
                  Save Hornbills may direct visitors to external conservation
                  organizations or fundraising platforms for donations and
                  support.
                </p>

                <p>
                  When donations occur on third-party platforms:
                </p>

                <ul>
                  <li>Payment details are processed directly by those providers</li>
                  <li>We do not store payment card information</li>
                  <li>We do not control third-party privacy practices</li>
                </ul>

                <p>
                  Users are encouraged to review the privacy policies of those
                  organizations before donating.
                </p>

                <h6 className="fw-bold mt-4">
                  Cookies & Analytics
                </h6>

                <p>
                  Our website may use cookies and analytics technologies to
                  improve usability and understand how visitors interact with
                  the platform.
                </p>

                <p>These tools may collect:</p>

                <ul>
                  <li>Device information</li>
                  <li>Browsing behavior</li>
                  <li>General geographic region</li>
                  <li>Referral sources</li>
                  <li>Anonymous visitor statistics</li>
                </ul>

                <p>
                  This data helps us improve content and conservation outreach.
                  We may use basic analytics tools that do not require
                  creating a user profile.
                </p>

                <h6 className="fw-bold mt-4">
                  Conservation Media & Educational Content
                </h6>

                <p>
                  The website may contain:
                </p>

                <ul>
                  <li>Wildlife photography</li>
                  <li>Conservation stories</li>
                  <li>Educational articles</li>
                  <li>Research summaries</li>
                  <li>Scientific references</li>
                </ul>

                <p>
                  Some visual resources may come from partner organizations,
                  photographers, researchers, or public educational sources
                  where usage rights allow educational distribution.
                </p>

                <h6 className="fw-bold mt-4">
                  Data Protection
                </h6>

                <p>
                  We take reasonable steps to safeguard information and
                  maintain secure systems.
                </p>

                <p>
                  However, no internet-based service can guarantee complete
                  security. Users share information at their own discretion and
                  risk.
                </p>

                <h6 className="fw-bold mt-4">
                  International Visitors
                </h6>

                <p>
                  Save Hornbills may be accessed globally.
                </p>

                <p>
                  By using the website, you acknowledge that your information
                  may be processed in countries where data protection laws
                  differ from your local jurisdiction.
                </p>

                <h6 className="fw-bold mt-4">
                  Children's Privacy
                </h6>

                <p>
                  This website is intended for a general audience and is not
                  specifically directed toward children under 13 years old.
                </p>

                <p>
                  We do not knowingly collect personal information from
                  children.
                </p>

                <p>
                  If we become aware that information from a child has been
                  submitted, we will take reasonable steps to remove it.
                </p>

                <h6 className="fw-bold mt-4">
                  Third-Party Links
                </h6>

                <p>
                  Our website may contain links to:
                </p>

                <ul>
                  <li>Conservation organizations</li>
                  <li>Research institutions</li>
                  <li>Educational resources</li>
                  <li>Fundraising platforms</li>
                  <li>Government resources</li>
                </ul>

                <p>
                  These websites operate under their own privacy policies or
                  terms of service. Users should independently review external
                  policies before engaging with these platforms.
                </p>

                <h6 className="fw-bold mt-4">
                  Policy Updates
                </h6>

                <p>
                  This Privacy Policy may occasionally be updated to reflect:
                </p>

                <ul>
                  <li>Legal requirements</li>
                  <li>Website improvements</li>
                  <li>Conservation partnerships</li>
                  <li>Operational changes</li>
                </ul>

                <p>
                  The latest version will always appear on this page with the
                  updated revision date.
                </p>

                <h6 className="fw-bold mt-4">
                  Contact
                </h6>

                <p>
                  For questions related to this Privacy Policy or website
                  usage, users may contact us through the website contact
                  section.
                </p>

                <p>
                  Thank you for supporting conservation awareness and helping
                  protect endangered hornbill species for future generations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PrivacyPolicy;